<template>
  <div v-for="syncModal in modalStore.syncModalStack" :key="syncModal.id">
    <article class="sync-modal">
      <component :is="syncModal.component" v-bind="syncModal.props" />
    </article>
  </div>
</template>

<script setup lang="ts">
  import { useModalStore } from '@/stores/modal';

  const modalStore = useModalStore();
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .sync-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: vars.$z-index-sync-modal;
  }
</style>
